// Event classes capturing currently supported event payload shapes.
// Previously auto-generated from a local sample file (events.json) which has been removed.
// Maintain these manually when introducing new event types or properties.

export type EventType = 'inventory.pick' | 'inventory.drop' | 'modal' | 'fire';

// Base class with common behavior 
export class Event {
  exerciseid: string = ''
  playerid: string = ''
  timestamp: number = 0
  type: string = "default"
}

export class InventoryPickEvent extends Event {
  data: { componentIndex: number; componentName: string; holder: string } = {
    componentIndex: 0,
    componentName: '',
    holder: 'Default'
  };
}

export class InventoryDropEvent extends Event {
  data: { holder: string; position: { x: number; y: number; z: number } } = {
    holder: 'Peter',
    position: {
      x: 1,
      y: 0,
      z: 1
    }
  }
}

export class ModalEvent extends Event {
  data: { action: string; modalId: string } = { action: 'nothing', modalId: 'empty' };
}

export class FireEvent extends Event {
  data: { action: string } = { action: 'nothing' };
}

export class WindDirectionEvent extends Event {
  data: { newDirection: string} = { newDirection: 'n' }; // possible values: n, ne, e, se, s, sw, w, nw
}

// Map an EventType string to the corresponding class constructor
export const EventTypeClassMap: Record<EventType, new () => Event> = {
  'inventory.pick': InventoryPickEvent,
  'inventory.drop': InventoryDropEvent,
  'modal': ModalEvent,
  'fire': FireEvent
};
